// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dVl5","col":"styles_col__Kbu6f"};